import { Pipe, PipeTransform } from '@angular/core';
import { LocationDto } from '../dto';

@Pipe({
    name: 'isUshq'
})
export class IsUshqPipe implements PipeTransform {
    transform(location: LocationDto): boolean {
        let hqLocations = location;
        if (Array.isArray(location)) {
            hqLocations = location.find((location) => location.is_ushq === true);
        }
        return hqLocations?.is_ushq;
    }
}